function initialize() {
    $('.page-tips-category select[name="category"]').on('change', function (evt) {
        if ($(this).val()) {
            window.location = '/dicas/categoria/' + $(this).val() + '#dicas';
        }
    });
}

initialize();
